import headInfosStatic from '../../public/data/headInfos.json';
export default headInfosStatic;
